<div class="main-wrapper">
  <div class="alert alert-info text-center fw-500" style="max-width:500px; margin:3% auto 0; line-height:normal;">No
    Record Found!
  </div>
</div>

